import { render, staticRenderFns } from "./MonitorCardToAssign.vue?vue&type=template&id=fbb9cc8e"
import script from "./MonitorCardToAssign.vue?vue&type=script&lang=js"
export * from "./MonitorCardToAssign.vue?vue&type=script&lang=js"
import style0 from "./MonitorCardToAssign.vue?vue&type=style&index=0&id=fbb9cc8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports